import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: "filterYoursToPlay",
    standalone: true,
})
@Injectable()
export class FilterYoursToPlay implements PipeTransform {

    transform(objects: any[], number: any): any[] {

        if (objects) {
            let returnArray = []
            let slideCount = Math.ceil(objects?.length / number)
            for (let i = 1; i <= slideCount; i++) {
                let slideArray = []
                returnArray.push(objects.filter((object, index) => {

                    if (index < i * number && index >= (i - 1) * number) {
                        slideArray.push(object)
                        return slideArray;
                    }

                }))
            }

            return returnArray
        }
    }
}
